module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_wisdom_m.fc668dcd7bde2f5e5d78619abf5fd60f.png";